export enum UserTypeEnum {
  LUX_ENGINE = 'LUX_ENGINE',
}
